"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentCollapse = void 0;
class ContentCollapse {
    static initCollapse() {
        var _a;
        (_a = document.querySelectorAll('.openCollapseBtn')) === null || _a === void 0 ? void 0 : _a.forEach((button) => {
            button.addEventListener('click', () => {
                var _a;
                (_a = button.parentElement) === null || _a === void 0 ? void 0 : _a.classList.toggle('open');
            });
        });
    }
}
exports.ContentCollapse = ContentCollapse;
